module.exports = __webpack_public_path__ + "fonts/rubik-regular-webfont.3abcd6e8.3abcd6e8.woff2";